// extracted by mini-css-extract-plugin
export default {"Label":"MediaLibraryTypeFilterGroup_Label__xL4Ik"};